import { createFileRoute } from "@tanstack/react-router";
import { DoctorDashboardPage } from "@/modules/doctors/presentation/pages/DoctorDashboardPage";

export const Route = createFileRoute("/doctor/")({
  component: DoctorDashboardPage,
});
